import { useInView } from "../hooks/useInView";
import { RevealChild } from "./Reveal";

const items = [
  {
    num: "01",
    title: "Architects secure cloud foundations",
    body: "AWS, containers, and Kubernetes platforms designed for scale. IAM hardening, network segmentation, and cost-aware infrastructure that doesn't break under load.",
  },
  {
    num: "02",
    title: "Builds CI/CD with guardrails",
    body: "Pipelines with security scanning, vulnerability feedback, and release controls baked in. GitHub Actions, GitLab CI, and GitOps patterns that teams actually use.",
  },
  {
    num: "03",
    title: "Synthesizes and writes from the field",
    body: "Every lesson from production becomes a Brain note or a blog post. 40+ pages on Kubernetes, security, observability, and AI-augmented workflows.",
  },
];

const WhatIDo = () => {
  const { ref, inView } = useInView({ threshold: 0.15 });

  return (
    <section className="py-12 text-light-text dark:text-text-primary" ref={ref}>
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <RevealChild visible={inView} delay={0}>
          <div className="mb-10">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent mb-3">
              What I Do
            </p>
            <h2 className="text-3xl md:text-4xl font-bold mb-4 leading-tight max-w-2xl tracking-tight">
              Cloud, delivery, security,{" "}
              <span className="text-accent">and the glue between them.</span>
            </h2>
          </div>
        </RevealChild>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map((item, i) => (
            <RevealChild key={item.num} visible={inView} delay={80 + i * 80}>
              <div className="group relative rounded-xl border border-light-border bg-light-surface p-6 dark:border-border-subtle dark:bg-surface-1 transition-all duration-300 hover:border-accent/20">
                <span className="mb-4 block font-mono text-[40px] font-bold leading-none text-accent/15">
                  {item.num}
                </span>
                <h3 className="mb-3 text-base font-semibold group-hover:text-accent transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm leading-relaxed text-light-muted dark:text-text-muted">
                  {item.body}
                </p>
              </div>
            </RevealChild>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatIDo;
